import { render, staticRenderFns } from "./RevisionVaccinate.vue?vue&type=template&id=4d9f52ce"
import script from "./RevisionVaccinate.vue?vue&type=script&lang=js"
export * from "./RevisionVaccinate.vue?vue&type=script&lang=js"
import style0 from "./RevisionVaccinate.vue?vue&type=style&index=0&id=4d9f52ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports